<template>
	<div>
		<!-- <div class="textCenter" v-if="isLoading">
              <Loading  :isLoading="true" ></Loading>
        </div> -->
	    <div class="main-container hotel-container" >
        <div class="rule">
            	<ul class="step">
                <li class="step-arrow "></li>
                  <li class="step-text ">预约信息</li>
                  <li class="step-arrow active"></li>
                  <li class="step-text active ">预约完成</li>
              </ul>
    			    <div class="back-btn-a" @click="returnBack">← 返回</div>
                <div class="main-left fill-order" v-if="reserveInfo">
                    <div class="title" id="floatTop">预约信息</div>
                    <div class="content" >
                        <p class="productName">{{reserveInfo.ProductName}}</p>
                        <div class="content-item-a">
                            <label class="item-title">预约号</label>
                            <div class="item-body">
                                <p class="time">{{Code}}</p>
                            </div>
                        </div>
                        <div class="content-item-a">
                            <label class="item-title">适用限制</label>
                            <div class="item-body">
                                <p class="time" style="color:#eb3941;font-weight:bold;">{{reserveInfo.TimeLimitTypeName}}</p>
                            </div>
                        </div>

                        <div class="content-item-a">
                            <label class="item-title">旅客姓名</label>
                            <div class='item-body'>
                                <div class="input-box">
                                    <input type="text" maxlength="50" placeholder="姓名" v-model="guestItem.CnName" >
                                    <i class="iconfont icon-guanbi user-close-btn" @click="guestItem.CnName=''" v-if="guestItem.CnName"></i>
                                </div>
                            </div>
                        </div>

                         <div class="content-item-a" v-if="reserveInfo.IsIdcard">
                            <label class="item-title">身份证号</label>
                            <div class='item-body'> 
                                <div class="input-box" >
                                    <input type="text" maxlength="50" placeholder="身份证号" v-model="guestItem.CardNumber" >
                                    <i class="iconfont icon-guanbi user-close-btn" @click="guestItem.CardNumber=''" v-if="guestItem.CardNumber"></i>
                                </div>
                            </div>
                        </div>

                        <div class="content-item-a">
                            <label class="item-title">手机号码</label>
                            <div class='item-body'> 
                                <div class="input-box">
                                    <input type="tel" maxlength="50" placeholder="为您更好地服务" v-model="guestItem.Phone" >
                                    <i class="iconfont icon-guanbi user-close-btn" @click="guestItem.Phone=''" v-if="guestItem.Phone"></i>
                                </div>
                            </div>
                        </div>

                        <div class="content-item-a">
                            <label class="item-title">特殊要求</label>
                            <div class='item-body'>
                                <div class="input-box" style="width: 400px;">
                                    <textarea type="text"  placeholder="描述" v-model="SpecialRequest" ></textarea>
                                </div>
                            </div>
                        </div>


                        <div class="title">特别说明</div>
                        <div class="content">预约后订单状态为“等待确认”状态，需等待酒店确认。有可能出现确认失败情况，若确认失败预约码状态会自动变更为“未预约”。</div>

                        <div class="title">关于发票</div>
                        <div v-for="N,index in reserveInfo.Notice" :key="index" v-if="index=='发票说明'">
                          <div class="content" v-html="N"></div>
                        </div>
                        <div class="content" v-if="!reserveInfo.Notice||!reserveInfo.Notice.发票说明"><p>★发票由我方开具，支持电子普通发票。<br/>★开具发票请提供准确的开票信息，电子普通发票请提供准确邮箱，不提供增值税专用发票。</p></div>
                        <div class="btn-group" id="stopScroll">
                            <div class="submit-btn" @click="checkBookAble">立即预约</div>
                        </div>
                    </div>
                </div>

                <div class="main-right">
                  <div class="date-picker-box" v-if="dailyData&&dailyData.length>0">
                    <div v-if="hDate">您选择的出发日期为：{{hDate}}</div>
                    <div class="hanleDate" v-if="!AllowCancel" style="color:#eb3941;">此订单即订即保，订单一经确认，不可取消更改</div>
                    <div class="hanleDate" v-if="AllowCancel&&CancelDate" style="color:#eb3941;">最后可取消时间为：{{CancelDate}}</div>
                    <div class="dpb-title">
                      <span @click="minus"><i class="iconfont icon-yuyin"></i></span>
                      <span>{{getMonths(number)}}</span>
                      <span @click="plus" style="transform: rotate(180deg);"><i class="iconfont icon-yuyin"></i></span>
                    </div>
                    <div class="dpb-week">
                      <table>
                        <thead>
                          <tr>
                            <th>日</th>
                            <th>一</th>
                            <th>二</th>
                            <th>三</th>
                            <th>四</th>
                            <th>五</th>
                            <th>六</th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                    <div class="dpb-week-days">
                      <div class="dpbwd-table" v-for="(item,index) in data" v-if="index==number">
                        <div class="dpbwd-table-items">
                          <table class="dpbwd-table-items-table">
                            <tbody >
                              <tr v-for="week in item">	
                                <td :class="day.isActive?'active':(day.isInRange?'range':day.isDisable?'disable':'')" v-for="(day,i) in week" @click="select(day)">
                                  <div :class="i==0||i==6?'weekcolor page-table-item':'page-table-item'">
                                    <div class="page-table-text">
                                      {{day.day}}
                                    </div>
                                    <div class="page-table-note" v-if="day.item">{{day.isDisable?'约满':'可约'}}</div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="reserveInfo&&reserveInfo.SkuPieceInfos.length>0" >
                    <div class="SkuTitle">产品包含</div>
                      <ul>
                        <li style="margin-bottom: 6px;" v-for="S,index in reserveInfo.SkuPieceInfos" :key="index"  v-html="S.PieceNameStr"></li>
                      </ul>
                  </div>


                </div>
            </div>
        </div>
        <Modal v-show="modal.show" :config="modal" @close="modal.show=false"></Modal>
	</div>

</template>
<script>
import Modal from "../../../common/cmpnt/Modal/modal.vue"; //跳转提示框
import Loading from "../../../common/cmpnt/Loading/Loading.vue"; //缓冲
export default {
  name: "book",
  components: { Modal, Loading },
  data() {
    return {
      data: [],
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      begin: "",
      end: "",
      hDate: "",
      dailyData: "",
      number: 0,
      guestItem: {
        CnName: "",
        CardNumber: "",
        Phone: this.dao.get("userInfo").Phone || ""
      },

      reserveData: "",
      SpecialRequest: "",
      isInvoiceBox: false,
      isInvoice: false,
      invoiceData: "",
      isSubmit: false,
      reserveInfo: "",
      Code: "",
      Token: "",
      Price: "",
      OrderNO: "",
      AllowCancel: false,
      CancelDate: "",

      modal: {
        show: false,
        config: {}
      }
    };
  },
  methods: {
    //选中日期
    select(day) {
      if (!day.isInRange) return;
      this.hDate = day.item.Date;
      this.Token = day.item.Token;
      this.Price = day.item.Price;
      this.tableDate();
    },
    //初始化表格数据
    tableDate() {
      var monthLength = 6;
      var data = [];
      // var date = new Date();
      var year = this.year; //获取完整的年份(4位)
      var month = this.month; //获取当前月份
      // console.log(year,month,monthLength)

      for (var i = 0; i < monthLength; i++) {
        var y = month + i > 12 ? year + 1 : year;
        var m = month + i > 12 ? month + i - 12 : month + i;
        // console.log(y,m)
        var re = this.monthDate(y, m < 10 ? "0" + m : m);
        data.push(re);
      }
      this.data = data;
    },

    //将数据格式化表格日期格式
    monthDate(year, month) {
      var that = this;
      //或取当前月份最后一天的日期
      var day = new Date(year, month, 0);
      var lastDay = day.getDate();
      //计算当前月份第一天是星期几
      var weekday = that.getWeekday(year + "-" + month + "-01");
      //定义存放当前月份的数组
      var data = [];
      //定义日期表格数组
      var result = [];
      //计算出当前月份每一天到数组中
      for (var day = 1; day <= lastDay; day++) {
        var day = day < 10 ? "0" + day : day;
        var date = year + "-" + month + "-" + day;
        var flag = true;
        var isInRange, isDisable, isActive;
        that.dailyData.forEach(item => {
          if (date == item.Date) {
            flag = false;
            if (date == that.hDate) {
              isActive = true;
            } else {
              isActive = false;
            }
            if (item.isBook) {
              isInRange = true;
              isDisable = false;
            } else {
              isInRange = false;
              isDisable = true;
              isActive = false;
            }
            data.push({
              day,
              month,
              year,
              isActive,
              isInRange,
              isDisable,
              item
            });
          }
        });
        if (flag) {
          isActive = false;
          isInRange = false;
          isDisable = true;
          data.push({
            day,
            month,
            year,
            isActive,
            isInRange,
            isDisable
          });
        }
      }

      //补全日期前几天
      for (var i = 0; i < weekday; i++) {
        data.unshift("");
      }
      //切成6行
      for (var i = 0, len = data.length; i < len; i += 7) {
        result.push(data.slice(i, i + 7));
      }
      //补全日期后几天
      var length = result[result.length - 1].length;
      if (length < 7) {
        for (var i = 0; i < 7 - length; i++) {
          result[result.length - 1].push("");
        }
      }
      return result;
    },

    //获取周几
    getWeekday(date) {
      // var nowDate = new Date();
      // var days = this.getDaysSize(nowDate, date);
      var mydate = new Date(date);
      var myday = mydate.getUTCDay(); //注:0-6对应为星期日到星期六
      return myday;
    },

    //获取天数差
    getDaysSize(s1, s2) {
      var s1 = new Date(s1);
      var s2 = new Date(s2);

      var days = s2.getTime() - s1.getTime();
      var time = parseInt(days / (1000 * 60 * 60 * 24));
      return time;
    },

    //减1
    minus() {
      if (this.number == 0) return;
      this.number -= 1;
    },
    //加1
    plus() {
      if (this.number >= 5) return;
      this.number += 1;
    },

    isPhoneAvailable(phone) {
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!myreg.test(phone)) {
        return false;
      } else {
        return true;
      }
    },

    checkBookAble() {
      var that = this;
      var SFreg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      var reg = new RegExp(
        "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
      );
      if (!that.hDate || !that.Token) {
        this.error({
          title: "提示",
          content: "您尚未选择有效出行日期!"
        });
        return;
      }
      if (that.reserveInfo.IsIdcard) {
        if (
          !(
            that.guestItem.CnName &&
            that.guestItem.Phone &&
            that.guestItem.CardNumber
          )
        ) {
          this.error({
            title: "提示",
            content: "您尚未选择有效出行日期!"
          });
          that.$alert("您有未填写的信息，请继续填写");
          return;
        } else if (!that.isPhoneAvailable(that.guestItem.Phone)) {
          this.error({
            title: "提示",
            content: "您的手机格式有误，请您核对"
          });
          return;
        } else if (!SFreg.test(that.guestItem.CardNumber)) {
          this.error({
            title: "提示",
            content: "您的身份证格式有误，请您核对"
          });
          return;
        }
      } else {
        if (!(that.guestItem.CnName && that.guestItem.Phone)) {
          this.error({
            title: "提示",
            content: "您有未填写的信息，请继续填写"
          });
          return;
        } else if (!that.isPhoneAvailable(that.guestItem.Phone)) {
          this.error({
            title: "提示",
            content: "您的手机格式有误，请您核对"
          });
          return;
        }
      }
      that.guestItem.NeedIDCard = that.reserveInfo.IsIdcard;

      var param = {
        Count: 1,
        Token: that.Token,
        Code: that.Code,
        CheckIn: that.hDate,
        CheckOut: that.getDate(1),
        QGOrderNo: that.reserveInfo.QGOrderNo,
        QGId: that.reserveInfo.QGId,
        Guests: [that.guestItem],
        SpecialRequest: that.SpecialRequest,
        IsInvoice: false,
        Invoices: "",
        IsDifference: false
      };

      that.modal = {
        show: true,
        content: "正在为您预约，请稍后...."
      };
      that
        .postRequest({
          url: that.Api.getPackageReserve,
          params: JSON.stringify(param)
        })
        .then(res => {
          that.modal.show = false;
          if (res && res.IsSuccess) {
            var QGOrderNo = res.Result.QGOrderNo;
            that.OrderNO = res.Result.MainOrderId;
            that.$router.replace(
              "/reserveDetails?OrderNO=" +
                that.OrderNO +
                "&QGOrderNo=" +
                QGOrderNo +
                "&Code=" +
                that.Code
            );
          } else if (!res.IsSuccess) {
            this.error({ title: "提示", content: res.Msg||'请求出错' });
          }
        });
    },

    //返回详情页
    returnBack() {
      window.history.go(-1);
    },

    //预约产品详情
    getReserveInfo() {
      var that = this;
      that.Code = that.$route.query.Code;
      that.reserveData = JSON.parse(this.dao.get("ReserveData"));
      var params = {
        ProductID: that.reserveData.ProductId,
        SkuID: that.reserveData.SKUId,
        Code: that.Code,
        QGOrderNo: that.reserveData.QGOrderNo,
        QGID: that.reserveData.QGId
      };
      that
        .postRequest({
          url: that.Api.getReserveInfo,
          params: params
        })
        .then(res => {
          if (res && res.IsSuccess) {
            that.reserveInfo = res.Result;
            that.getPackageDaily();
            that.$nextTick(() => {
              if(localStorage.getItem('lang')=='t'){
                that.$zh_tran(localStorage.getItem('lang'))
              }        
            })
          } else {
            this.error({ title: "提示", content: res.Msg||'请求出错!请重新进入'});
          }
        });
    },

    //获取价格日历
    getPackageDaily() {
      var that = this;
      var start = "";
      if (
        that.getDays(
          that.dateToYMDline(that.reserveInfo.StartActiveDate),
          that.getDate(0)
        ) > 0
      ) {
        start = that.getDate(0);
      } else {
        start = that.dateToYMDline(that.reserveInfo.StartActiveDate);
      }
      var params = {
        HotelID: that.reserveInfo.HotelId,
        RoomID: that.reserveInfo.RoomId,
        RPID: that.reserveInfo.RpId,
        RateID: that.reserveInfo.RateId,
        ProductID: that.reserveInfo.ProductId,
        SKUID: that.reserveInfo.SkuID,
        Start: start,
        End: that.dateToYMDline(that.reserveInfo.EndActiveDate)
      };
      that
        .postRequest({
          url: that.Api.getPackagePrices,
          params: params
        })
        .then(res => {
          that.isDaily = false;
          that.ShowSKU = false;
          if (res && res.IsSuccess) {
            var data = res.Result.reverse();
            var arr = [];
            data.forEach(item => {
              if (!item.Status) {
                if (item.IsAskRoom || (!item.IsAskRoom && item.Stock > 0)) {
                  item.isBook = true;
                } else {
                  item.isBook = false;
                }
              } else {
                item.isBook = false;
              }
              item.Date = item.Date.slice(0, 10);
              arr.push(item);
            });
            that.dailyData = arr;
            var index = 0;
            var flag = true;
            for (var i = 0; i < arr.length; i++) {
              if (arr[i].isBook && flag) {
                index = i;
                flag = false;
              }
            }
            that.dailyData = arr;
            that.hDate = arr[index].Date;
            that.Token = arr[index].Token;
            that.Price = arr[index].Price;
            that.AllowCancel = arr[index].AllowCancel;
            that.CancelDate = arr[index].CancelDate;
            // 计算月份差
            var dt1 = that.hDate;
            var dt2 = that.getDate(0);
            dt1 = dt1.split("-");
            dt1 = parseInt(dt1[0]) * 12 + parseInt(dt1[1]);
            dt2 = dt2.split("-");
            dt2 = parseInt(dt2[0]) * 12 + parseInt(dt2[1]);
            var num = Math.abs(dt1 - dt2);
            that.number = num;
            var length = that.dailyData.length - 1;
            that.begin = that.dailyData[0].Date;
            that.end = that.dailyData[length].Date;
            that.tableDate();
            that.$nextTick(() => {
              if(localStorage.getItem('lang')=='t'){
                that.$zh_tran(localStorage.getItem('lang'))
              }         
            })
          } else {
            this.dailyData = "";
            that.SKUdata.forEach(item => {
              item.active = false;
            });
            this.error({
              title: "提示",
              content: "该套餐已售罄！"
            });
            this.Price = "";
          }
        });
    }
  },
  mounted() {
    this.getReserveInfo();
  },
  destroyed() {}
};
</script>
<style scoped>
.hanleDate {
  margin: 10px 0;
}

.SkuTitle {
  font-size: 18px;
  font-weight: bold;
  margin: 20px 0;
}

.hotel-container .main-right {
  border: 0;
}

.hotel-container .item-body {
  width: 60%;
}

.hotel-container .item-body .input-box {
  width: 300px;
}

.hotel-container .item-body textarea {
  width: 100%;
  height: 60px;
  resize: none;
  padding: 2px 10px 2px 0;
}

.hotel-container .main-left .title {
  margin: 20px 0;
}

.content .productName {
  font-size: 16px;
  font-weight: bold;
  padding: 0 10px;
  margin-bottom: 15px;
}

.weekcolor .page-table-text {
  color: #28c667;
}
.active .weekcolor {
  color: #fff !important;
}
.dpb-title {
  height: 40px;
  text-align: center;
  line-height: 40px;
  background: #edeef2;
  font-size: 15px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.dpb-title i {
  color: #2391ff;
  padding: 5px;
  background-color: #fff;
  cursor: pointer;
}

.dpb-week > table {
  background: #fff;
  font-size: 13px;
  width: 100%;
  border-collapse: separate;
  table-layout: fixed;
}
.dpb-week > table > thead > tr > th {
  height: 30px;
  text-align: center;
  font-weight: 400;
  /* border-bottom: 1px solid #e0e0e0; */
  width: 14.28571%;
  vertical-align: middle;
}
.dpb-week-days {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
}
.dpbwd-table-month {
  height: 30px;
  display: -webkit-box;
  -webkit-box-align: center;
  -webkit-box-pack: center;
  font-size: 15px;
  font-weight: 700;
  background: hsla(210, 8%, 95%, 0.9);
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1;
  /* border-bottom: 1px solid #e0e0e0; */
}
.page-table-item {
  box-sizing: border-box;
  position: relative;
  /*display: -webkit-box;*/
  -webkit-box-orient: vertical;
  -webkit-box-align: center;
  -webkit-box-pack: end;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
}
.page-table-text {
  font-size: 13px;
  height: 15px;
  line-height: 15px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.page-table-note {
  color: #fb8800;
  font-size: 12px;
  height: 15px;
  line-height: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-style: inherit;
}
.page-table-note,
.page-table-text {
  display: block;
  width: 100%;
  text-align: center;
}

.active .page-table-note,
.active .page-table-text {
  color: #fff;
}
.dpbwd-table-items-table > tbody > tr > td.disable .page-table-text,
.dpbwd-table-items-table > tbody > tr > td.disable .page-table-note {
  color: #ccc !important;
  background: none !important;
}
.dpbwd-table-items-table > tbody > tr > td.range {
  background: #e8f4ff;
  cursor: pointer;
}
.dpbwd-table-items-table.flag > tbody > tr > td.range {
  background: #e8f4ff;
  cursor: not-allowed;
}
.dpbwd-table-items-table > tbody > tr > td.active {
  cursor: pointer;
  color: #fff;
  background: #2391ff;
}
.dpbwd-table-items-table > tbody > tr > td {
  height: 55px;
  width: 13.6%;
  position: relative;
  background-color: #f8f8f8;
  display: inline-block;
  margin: 1px;
  cursor: not-allowed;
}
.dpbwd-table-items-table {
  width: 100%;
  border-collapse: separate;
  table-layout: fixed;
}
</style>



// WEBPACK FOOTER //
// src/components/package/reserve/book.vue